import intl from 'react-intl-universal';
import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import { Link } from '@components';
import { withRouter } from 'react-router';
import './Header.scss';

class Header extends Component {
  render() {
    return (
      <div className="wy-header">
        <nav>
          <ul>
            <li>
              <Link to="/" activeClassName="wy-active-link" exact>
                {intl.get('NAVEGACAO.HOME')}
              </Link>
            </li>
            <li>
              <Link to="/about" activeClassName="wy-active-link">
                {intl.get('NAVEGACAO.ABOUT_ME')}
              </Link>
            </li>
            <li>
              <Link to="/work" activeClassName="wy-active-link">
                {intl.get('NAVEGACAO.WORK')}
              </Link>
            </li>
            <li>
              <Link href="mailto:oi@wylkon.com.br" activeClassName="wy-active-link">
                {intl.get('NAVEGACAO.CONTACT')}
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    );
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/organisms/Header/Header.jsx